import React, { useState } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Person from "@material-ui/icons/Person";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import OSSTextOverflowTooltip from "../OSSTextOverflowTooltip/OSSTextOverflowTooltip";

const styles = theme => ({
  paper: {
    maxWidth: theme.spacing(30)
  },
  menuLink: {
    textDecoration: "none",
    color: "inherit"
  },
  primary: {
    fontFamily: theme.typography.brand.fontFamily,
    fontSize: 14,
    color: theme.palette.secondary.main
  },
  listItemTextRoot: {
    padding: 0
  },
  userEmailIcon: {
    marginRight: theme.spacing(1),
    color: theme.palette.common.white,
    background: theme.palette.secondary.main,
    borderRadius: 4,
    padding: 3,
    fontSize: theme.typography.pxToRem(17),
    minWidth: "auto"
  },
  menuItemRoot: {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    fontFamily: theme.typography.brand.fontFamily,
    fontSize: 14
  },
  userEmailMenuItem: {
    cursor: "auto",
    "&:hover, &:focus": {
      backgroundColor: theme.palette.common.white
    }
  },
  userEmailMenuItemSelected: {
    backgroundColor: theme.palette.common.white
  }
});

const OSSUserMenu = ({ logout, classes, userEmail }) => {
  const [userEl, setUserEl] = useState(null);
  const handleUserMenuClick = event => {
    setUserEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setUserEl(null);
  };

  const handleLogout = () => {
    handleUserMenuClose();
    logout();
  };

  return (
    <>
      <IconButton
        id="user"
        aria-owns={userEl ? "user-menu" : null}
        aria-haspopup="true"
        aria-label="User Menu"
        onClick={handleUserMenuClick}
      >
        <Person />
      </IconButton>

      <Menu
        id="user-menu"
        anchorEl={userEl}
        open={Boolean(userEl)}
        onClose={handleUserMenuClose}
        classes={{ paper: classes.paper }}
        transformOrigin={{
          vertical: -50,
          horizontal: 50
        }}
      >
        {userEmail && (
          <MenuItem
            classes={{
              root: classes.menuItemRoot,
              selected: classes.userEmailMenuItemSelected
            }}
            className={classes.userEmailMenuItem}
          >
            <ListItemIcon className={classes.userEmailIcon}>
              <Person fontSize="inherit" />
            </ListItemIcon>
            <ListItemText
              classes={{
                root: classes.listItemTextRoot,
                primary: classes.primary
              }}
              primary={
                <OSSTextOverflowTooltip>{userEmail}</OSSTextOverflowTooltip>
              }
            />
          </MenuItem>
        )}
        <a
          className={classes.menuLink}
          href={`${window.REACT_APP_SSO_URL}/resetpassword`}
        >
          <MenuItem classes={{ root: classes.menuItemRoot }}>
            Reset Password
          </MenuItem>
        </a>
        <MenuItem
          classes={{ root: classes.menuItemRoot }}
          onClick={handleLogout}
        >
          Log Out
        </MenuItem>
      </Menu>
    </>
  );
};

export default withStyles(styles)(OSSUserMenu);
